import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import TermsConditions from './pages/TermsConditions';
import SafetyGuidelines from './pages/SafetyGuidelines';
import HelpCenter from './pages/HelpCenter';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';
import OurTeam from './pages/OurTeam';
import Pricing from './pages/Pricing';
import HowItWorksPage from './pages/HowItWorksPage';
import AccountDeletionRequest from './pages/AccountDeletionRequest';
import CampaignRedirect from './pages/CampaignRedirect';
import { ThemeProvider } from './context/ThemeContext';

import './App.css'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/terms-conditions" element={<TermsConditions />} />
      <Route path="/safety" element={<SafetyGuidelines />} />
      <Route path="/help" element={<HelpCenter />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/our-team" element={<OurTeam />} />
      <Route path="/drivers/account-deletion-request" element={<AccountDeletionRequest role="driver" />} />
      <Route path="/riders/account-deletion-request" element={<AccountDeletionRequest role="rider" />} />
      <Route path="/r/:campaignId" element={<CampaignRedirect app="rider" />} />
      <Route path="/d/:campaignId" element={<CampaignRedirect app="driver" />} />
      {/* Catch-all route for 404 pages - must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppRoutes />
      </Router>
    </ThemeProvider>
  );
}

export default App;
